import { __makeTemplateObject, __rest } from "tslib";
import { css } from 'styled-components';
import Flex from '../Flex';
import { createComponent } from '../utils';
var getWidthPercent = function (width, columns) { return (width / columns) * 100 + "%"; };
var getColumnWidth = function (width, columns) {
    if (width / columns !== 1) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: block;\n      flex-basis: ", ";\n      max-width: ", ";\n    "], ["\n      display: block;\n      flex-basis: ", ";\n      max-width: ", ";\n    "])), getWidthPercent(width, columns), getWidthPercent(width, columns));
    }
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    max-width: 100%;\n    width: 100%;\n    flex: auto;\n  "], ["\n    max-width: 100%;\n    width: 100%;\n    flex: auto;\n  "])));
};
var getPadding = function (_a) {
    var collapse = _a.collapse, gutter = _a.gutter, theme = _a.theme;
    if (collapse) {
        return 0;
    }
    return typeof gutter === 'number' ? gutter / 2 : theme.gridGutter / 2;
};
var getOffset = function (offset, columns) { return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: ", ";\n"], ["\n  margin-left: ", ";\n"])), offset === 0 ? 0 : getWidthPercent(offset, columns)); };
export var Column = createComponent({
    name: 'Column',
    as: Flex,
    style: function (_a) {
        var theme = _a.theme, order = _a.order, props = __rest(_a, ["theme", "order"]);
        var mediaQueries = Object.keys(theme.breakpoints).map(function (breakpoint) {
            if (!props[breakpoint]) {
                return null;
            }
            if (breakpoint === 'xs') {
                return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          ", ";\n          ", ";\n        "], ["\n          ", ";\n          ", ";\n        "])), getColumnWidth(props[breakpoint] || 0, theme.gridColumns), props[breakpoint + "Offset"] && getOffset(props[breakpoint + "Offset"], theme.gridColumns));
            }
            return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        @media (min-width: ", ") {\n          ", ";\n          ", ";\n        }\n      "], ["\n        @media (min-width: ", ") {\n          ", ";\n          ", ";\n        }\n      "])), theme.breakpoints[breakpoint], getColumnWidth(props[breakpoint], theme.gridColumns), props[breakpoint + "Offset"] !== undefined && getOffset(props[breakpoint + "Offset"], theme.gridColumns));
        });
        return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      box-sizing: border-box;\n      flex: 1 0 auto;\n      flex-direction: column;\n      padding-left: ", "px;\n      padding-right: ", "px;\n\n      ", ";\n    "], ["\n      box-sizing: border-box;\n      flex: 1 0 auto;\n      flex-direction: column;\n      padding-left: ", "px;\n      padding-right: ", "px;\n\n      ", ";\n    "])), getPadding, getPadding, mediaQueries);
    },
});
Column.defaultProps = {
    collapse: false,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Column.js.map